/**
 * MO Cart Handler - Bundle removal for cart line items
 * Migrated from src/alpine/store/custom-cart-handler.js
 */
(function () {
  "use strict";

  window.MO = window.MO || {};

  var ACCESSORY_TAG = "accessories";
  var ACCESSORY_TYPE = "accessories";
  var SERVICE_KEY = "Service";
  var SERVICE_VALUE_ACCESSORY = "MJH";
  var SERVICE_VALUE_PRISM = "FOCM";

  function readCartMeta(form) {
    var node =
      (form && form.querySelector("[data-mo-cart-meta]")) ||
      document.querySelector("[data-mo-cart-meta]");
    if (!node) return [];
    try {
      var parsed = JSON.parse(node.textContent || "[]");
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      console.warn("[MO.cartHandler] meta JSON parse failed:", e);
      return [];
    }
  }

  function hasAccessoryFlag(metaEntry) {
    if (!metaEntry) return false;
    var type = (metaEntry.type || "").toLowerCase();
    if (type === ACCESSORY_TYPE) return true;
    var tags = Array.isArray(metaEntry.tags) ? metaEntry.tags : [];
    for (var i = 0; i < tags.length; i++) {
      if ((tags[i] || "").toLowerCase() === ACCESSORY_TAG) return true;
    }
    return false;
  }

  function isRxLensItem(item) {
    return !!(item && item.properties && item.properties.rxOrder === "true");
  }

  function isPrismItem(item) {
    return !!(item && item.properties && item.properties.isPrism === "true");
  }

  function desiredServiceFor(item, hasAccessory) {
    if (hasAccessory) return SERVICE_VALUE_ACCESSORY;
    if (isPrismItem(item)) return SERVICE_VALUE_PRISM;
    return "";
  }

  async function patchRxServiceBeforeCheckout(form) {
    var meta = readCartMeta(form);
    var metaByKey = {};
    for (var i = 0; i < meta.length; i++) {
      if (meta[i] && meta[i].key) metaByKey[meta[i].key] = meta[i];
    }

    var cart = await MO.api.getCart();
    var items = (cart && cart.items) || [];

    var hasAccessory = items.some(function (item) {
      return hasAccessoryFlag(metaByKey[item.key]);
    });

    var rxLines = items.filter(isRxLensItem);
    for (var j = 0; j < rxLines.length; j++) {
      var line = rxLines[j];
      var currentProps = line.properties || {};
      var current = currentProps[SERVICE_KEY] || "";
      var desired = desiredServiceFor(line, hasAccessory);
      if (current === desired) continue;

      var newProps = Object.assign({}, currentProps);
      if (desired === "") {
        delete newProps[SERVICE_KEY];
      } else {
        newProps[SERVICE_KEY] = desired;
      }
      await MO.api.changeItem({ id: line.key, properties: newProps });
    }
  }

  function initCheckoutServicePatch() {
    document.addEventListener(
      "submit",
      function (e) {
        var form = e.target;
        if (!(form instanceof HTMLFormElement)) return;
        var submitter = e.submitter;
        if (!submitter || submitter.getAttribute("name") !== "checkout") return;
        if (form._moRxServicePatched) {
          form._moRxServicePatched = false;
          return;
        }

        e.preventDefault();
        submitter.disabled = true;

        patchRxServiceBeforeCheckout(form)
          .catch(function (err) {
            console.error("[MO.cartHandler] RX service patch failed:", err);
          })
          .then(function () {
            submitter.disabled = false;
            form._moRxServicePatched = true;
            if (typeof form.requestSubmit === "function") {
              form.requestSubmit(submitter);
            } else {
              submitter.click();
            }
          });
      },
      true
    );
  }

  window.MO.cartHandler = {
    init: function () {
      var self = this;
      setTimeout(function () {
        self.initCartLineItemTriggers();
      }, 400);

      window.addEventListener("SCE:mutate", function () {
        setTimeout(function () {
          self.initCartLineItemTriggers();
        }, 400);
      });

      initCheckoutServicePatch();
    },

    getCart: async function () {
      var res = await fetch(window.Shopify.routes.root + "cart.js");
      return res.json();
    },

    initCartLineItemTriggers: function () {
      var allRemoveButtons = document.querySelectorAll("[ev-remove-btn]");
      if (allRemoveButtons.length === 0) return;

      allRemoveButtons.forEach(function (btn) {
        // Prevent double-binding
        if (btn._moCartBound) return;
        btn._moCartBound = true;

        btn.addEventListener("click", async function () {
          var bundleHash = btn.dataset.bundleHash;
          var updates = {};
          document
            .querySelectorAll('[data-bundle-hash="' + bundleHash + '"]')
            .forEach(function (el) {
              updates[el.dataset.key] = 0;
            });

          await fetch(window.Shopify.routes.root + "cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ updates: updates })
          });

          window.location.reload();
        });
      });
    }
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initCheckoutServicePatch);
  } else {
    initCheckoutServicePatch();
  }
})();
